import { render } from "./EconomicInformation.vue?vue&type=template&id=2eccb914&scoped=true&lang=html"
import script from "./EconomicInformation.vue?vue&type=script&lang=js"
export * from "./EconomicInformation.vue?vue&type=script&lang=js"

import "./EconomicInformation.vue?vue&type=style&index=0&id=2eccb914&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eccb914"]])

export default __exports__